export var ACTIVITY = 'activity';
export var AMENITY = 'amenity';
export var LEVEL = 'level';
export var LOCATION = 'location';
export var MOVEMENT = 'movement';